import client from '../client';
import qs from 'qs';
import { PopupListPayload } from './types';

export const operationApis = {
  // 엣지크로스 통합
  getSolutionRequestList: (data: {
    page: number;
    size: number;
    filterField: string;
    filterValue: string;
    searchField: string;
    searchValue: string;
    sortBy: string;
    isAsc: boolean;
  }) => client.get(`/home/solution/lead`, { params: data }),

  // 엣지크로스 공지사항
  getNoticeList: (data: {
    page: number;
    size: number;
    search?: { title: string };
    filter?: { solutionCd: string; noticeCd: string };
  }) =>
    client.get(`/notice`, {
      params: { ...data },
      paramsSerializer: {
        serialize: function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
      },
    }),
  getNoticeDetail: (id: string) => client.get(`/notice/${id}`),
  createNotice: (data: any) => client.post(`/notice`, data),
  updateNotice: (data: any) => client.put(`/notice/${data.id}`, data),
  deleteNotice: (id: string) => client.delete(`/notice/${id}`),
  uploadImage: (data: FormData) =>
    client.post(`/notice/image`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 공지사항 팝업
  getPopupList: (data: PopupListPayload) =>
    client.get(`/popup`, {
      params: { ...data },
      paramsSerializer: {
        serialize: function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
      },
    }),
  getPopupDetail: (id: number) => client.get(`/popup/${id}`),
  postPopup: (data: any) => client.post(`/popup`, data),
  putPopup: (data: any) => client.put(`/popup/${data.popupId}`, data.data),
  deletePopup: (id: string) => client.delete(`/popup/${id}`),
  uploadPopupImage: (data: FormData) =>
    client.post(`/popup/image`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
};
